import { Types } from '@store/types';

const initialState = [];

const SeasonReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_SEASON_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default SeasonReducer;
